import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8d777cee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "UserManagementBox" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content-left" }
const _hoisted_4 = { class: "top" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "租户 ", -1))
const _hoisted_7 = { class: "bottom" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"red","text-align":"center"} }, "组织机构", -1))
const _hoisted_9 = { class: "scrollable-tree" }
const _hoisted_10 = { class: "content-right" }
const _hoisted_11 = {
  class: "operationCont",
  style: {"display":"flex","justify-content":"flex-end"}
}
const _hoisted_12 = { class: "UserManagement-table" }
const _hoisted_13 = { class: "paginationCont" }
const _hoisted_14 = { class: "dialogBox" }
const _hoisted_15 = {
  key: 0,
  class: "pwd-strength-meter"
}
const _hoisted_16 = { class: "pwd-strength-bars" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "password-tip" }, " 温馨提示：密码需要8-18位，且包含至少一个字母+至少一个数字，@$!%*#?&中至少一个特殊字符。 ", -1))
const _hoisted_18 = { class: "dialog-footer" }

import { ref, reactive, onMounted, getCurrentInstance, toRaw, computed, nextTick, onUnmounted, watch } from "vue";
import { FormInstance, FormRules, ElMessage, ElMessageBox } from "element-plus";
import { ElTree } from "element-plus";
import { useRouter } from "vue-router";
import { setField, isMatchPwd } from "../../utiles/utiles";
import { Search, RefreshRight, Plus } from "@element-plus/icons-vue";
import { getListCompanyInfo } from "@/views/Login/api";
import {
  getPage,
  getDeptTree,
  deptTreeByCompCode,
  saveOrUpdate,
  updateEnableFlag,
  resetPw,
} from "./api.js";
import { getPage as rolePage } from "@/views/roleManagement/api.js";
interface ruleFormConfigItem {
  id: string;
  compCode: string;
  userName: string;
  password: string;
  confirmPassword: string;
  userAccount: string;
  phone: string;
  deptId: string;
  roleId: string | number;
  enableFlag: string | null;
  remark: string;
}

// 实时提示文本

export default /*#__PURE__*/_defineComponent({
  __name: 'userManage',
  setup(__props) {

const passwordValidationMessage = computed(() => {
  if (!ruleForm.password) return '';

  const errors = [];
  if (ruleForm.password.length < 8 || ruleForm.password.length > 18) {
    errors.push('密码长度需要在8-18位之间');
  }
  if (!/[A-Za-z]/.test(ruleForm.password)) {
    errors.push('需要包含至少一个字母');
  }
  if (!/[0-9]/.test(ruleForm.password)) {
    errors.push('需要包含至少一个数字');
  }
  if (!/[@$!%*#?&]/.test(ruleForm.password)) {
    errors.push('需要包含至少一个特殊字符(@$!%*#?&)');
  }

  // 如果没有错误，就提示“新密码格式正确”，否则将所有错误用换行拼起来
  return errors.length === 0 ? '新密码格式正确' : errors.join('\n');
});

// 密码强度等级：0 不显示，1=弱，2=中，3=强
const strengthLevel = computed(() => {
  const pwd = ruleForm.password;
  if (!pwd) return 0;

  let score = 0;
  if (pwd.length >= 8) score++;
  // 包含字母
  if (/[A-Za-z]/.test(pwd)) score++;
  // 包含数字
  if (/[0-9]/.test(pwd)) score++;
  // 包含特殊字符
  if (/[@$!%*#?&]/.test(pwd)) score++;

  if (score <= 2) return 1;
  if (score === 3) return 2;
  return 3;
});
const defaultProps = {
  children: "children",
  label: "label",
};
let userInfo = sessionStorage.getItem("userInfo")
  ? JSON.parse(sessionStorage.getItem("userInfo") || "")
  : "";
const queryFormRef = ref<FormInstance>();
const ruleFormRef = ref<FormInstance>();
const treeRef = ref<InstanceType<typeof ElTree> | null>(null);
const deptIdsParams = ref([]);
const Router = useRouter();
const pageSizes = ref([10, 20, 50]);
const hasInitialSearch = ref(false);

const userManuallySetPageSize = ref(false);
const calculateTableRows = () => {
  // 如果用户手动设置了页面大小，则不进行自动计算
  if (userManuallySetPageSize.value) {
    return;
  }
  const tableContainer = document.querySelector('.UserManagement-table');
  if (!tableContainer) {
    console.log('未找到表格容器');
    return;
  }

  const allRows = document.querySelectorAll('.el-table__row');
  if (!allRows.length) {
    if (!hasInitialSearch.value) {
      hasInitialSearch.value = true;
      onSearch(false);
    }
    return;
  }

  // 计算新的 pageSize
  const totalHeight = Array.from(allRows).reduce((sum, row) => {
    return sum + row.getBoundingClientRect().height;
  }, 0);
  const rowHeight = totalHeight / allRows.length;
  const containerHeight = tableContainer.clientHeight;
  const tableHeader = document.querySelector('.el-table__header');
  const headerHeight = tableHeader ? tableHeader.getBoundingClientRect().height : 0;
  const availableHeight = containerHeight - headerHeight;
  const maxRows = Math.floor(availableHeight / rowHeight);
  const calculatedSize = Math.ceil(maxRows / 5) * 5;

  if (queryForm.pageSize === calculatedSize) {
    return;  // 如果分页大小没变，直接返回
  }

  // 更新分页相关配置
  pageSizes.value = [calculatedSize, calculatedSize * 2, calculatedSize * 3];
  defaultPageSize.value = calculatedSize;
  queryForm.pageSize = calculatedSize;
  onSearch(true);
};
const defaultPageSize = ref(10);
let queryForm = reactive({
  condition: {
    deptIdsParams: [],
    deptIdsParam: [],
    compCode: userInfo.compCode,
    deptId: "",
    roleId: "",
    userName: "",
    password: "",
    confirmPassword: "",
  },
  pageIndex: 1,
  pageSize: defaultPageSize.value,
});
const tableData = ref<any>([]);
const deptTree = ref<any>([]);
const ScreenDeptTree = ref<any>([]);
const dialogVisible = ref(false);
const dialogTitle = ref<string>("新增用户");
const total = ref<number>(0);
const formSize = ref("default");
let isAdmin = ref(false);
const ruleForm = reactive<ruleFormConfigItem>({
  id: "",
  compCode: "",
  userName: "",
  userAccount: "",
  password: "",
  confirmPassword: "",
  phone: "",
  deptId: "",
  roleId: "",
  enableFlag: "Y",
  remark: "",
});
const validatePhone = (rule: any, value: any, callback: any) => {
  if (value) {
    let reg = new RegExp(/^1[3456789]\d{9}$/);
    if (!reg.test(value)) {
      callback("请录入正确的联系电话");
    } else {
      callback();
    }
  } else {
    callback();
  }
};

const checkAccount = (rule: any, value: any, callback: any) => {
  if (value) {
    const reg = /^[A-Za-z0-9]+$/;
    if (!reg.test(value)) {
      callback("登录账号校验大小写字母或数字");
    } else {
      callback();
    }
  } else {
    callback("请录入不限位数的大小写字母或数字的登录账号");
  }
};
const validatePassword = (rule: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('请输入密码'))
  } else if (!isMatchPwd(value)) {
    callback('请按照密码规则修改')
  } else {
    callback()
  }
}

const validatePasswordConfirm = (rule: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('请输入密码'))
  } else if (value !== ruleForm.password) {
    callback(new Error("两次输入密码不一致"))
  } else if (!isMatchPwd(value)) {
    callback('请按照密码规则修改')
  } else {
    callback()
  }
}
const talentArr = ref<any>([]);
const roleList = ref<any>([]);
const rules = reactive<FormRules>({
  userName: [{ required: true, message: "请输入用户姓名", trigger: "blur" }],
  userAccount: [{ required: true, validator: checkAccount, trigger: "blur" }],
  phone: [{ validator: validatePhone, trigger: "blur", required: false }],
  deptId: [
    {
      required: true,
      message: "请选择归属机构",
      trigger: "change",
    },
  ],
  loginAccess: [
    {
      required: true,
      message: "请选择登录权限",
      trigger: "change",
    },
  ],
  userType: [
    {
      required: true,
      message: "请选择用户类型",
      trigger: "change",
    },
  ],
  userRole: [
    {
      required: true,
      message: "请选择用户角色",
      trigger: "change",
    },
  ],
  password: [{ validator: validatePassword, trigger: "blur" }],
  confirmPassword: [{ validator: validatePasswordConfirm, trigger: "blur" }],
});

const { proxy }: any = getCurrentInstance();
onMounted(() => {
  nextTick(() => {
    calculateTableRows();
  });
  let name = toRaw(Router).currentRoute.value.name;
  proxy.$doResize(name);
  getDeptTreeFn();
  // getScreenDeptTreeFn();
  // onSearch(true);
  getRoleList();
  getListCompanyInfos();
  isAdmin.value =
    (sessionStorage.getItem("userInfo")
      ? JSON.parse(sessionStorage.getItem("userInfo") || "").id
      : false) == "0";
  const debouncedCalculate = debounce(calculateTableRows, 200);
  window.addEventListener('resize', debouncedCalculate);
});
watch(tableData, () => {
    if (tableData.value.length > 0) {  // 只在有数据时才重新计算
        nextTick(() => {
            calculateTableRows();
        });
    }
}, { immediate: false });
onUnmounted(() => {
    window.removeEventListener('resize', calculateTableRows);
    userManuallySetPageSize.value = false;
});
const debounce = (fn: Function, delay: number) => {
    let timer: any = null;
    return function (this: any, ...args: any[]) {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            userManuallySetPageSize.value = false; // 重置标志位
            fn.apply(this, args);
        }, delay);
    };
};

const getListCompanyInfos = () => {
  getListCompanyInfo().then((res: any) => {
    console.log(res);
    talentArr.value = res;
  });
};
const getRoleList = () => {
  rolePage({
    condition: {
      compCode: ruleForm.compCode || queryForm.condition.compCode,
    },
    pageIndex: 1,
    pageSize: 999,
  }).then((res: any) => {
    const { items, totalSize } = res;
    roleList.value = items;
  });
};
const getDeptTreeFn = () => {

  if (queryForm.condition.compCode) {
    deptTreeByCompCode(queryForm.condition.compCode).then((res: any) => {
      deptTree.value = res;
      ruleForm.deptId = deptTree.value[0].value
      console.log('222', deptTree.value[0].value);
    });
    // ruleForm.deptId = deptTree.value[0].value


  } else {
    // getDeptTree("Y").then((res: any) => {
    //   deptTree.value = res;
    // });
    queryForm.condition.compCode = userInfo.compCode
  }
  onSearch(true);
  getRoleList();
};
const getScreenDeptTreeFn = () => {
  getDeptTree("Y").then((res: any) => {
    ScreenDeptTree.value = res;
  });
};
const handleCheck = (x, y) => {
  if (treeRef.value) {
    const checkedNodes = treeRef.value.getCheckedNodes(false, false);
    deptIdsParams.value = checkedNodes.map((item) => item.value);
    console.log("x", x);
    ruleForm.compCode = x.compCode;
    ruleForm.deptId = x.value
    onSearch(true);
    getRoleList();
  }
};
const changeCompCode = (item, node) => {
  ruleForm.compCode = item.compCode;
  getRoleList()
  console.log("ruleForm.compCode", ruleForm.compCode);
};
const onSearch = (type: boolean) => {
  if (type) {
    queryForm.pageIndex = 1;
  }
  if (treeRef.value) {
    queryForm.condition.deptIdsParams = deptIdsParams;
  }

  getPage(queryForm).then((res: any) => {
    const { items, totalSize } = res;
    total.value = Number(totalSize);
    tableData.value = items;
  });
  console.log("submit!", queryForm);
};

const updateEnableFlagFn = (value: string, id: string) => {
  console.log("1111111", value);
  let param = {
    id: id,
    enableFlag: value,
  };
  updateEnableFlag(param)
    .then((res: any) => {
      ElMessage({
        type: "success",
        message: "切换成功",
      });
      onSearch(false);
    })
    .catch((err: any) => {
      onSearch(false);
    });
};
const newlyAdded = () => {

  ruleForm.confirmPassword = ''
  ruleForm.deptId = ruleForm.deptId || deptIdsParams.value[0];
  dialogTitle.value = "新增用户";
  dialogVisible.value = true;
  console.log('ruleForm', ruleForm);
};
const resetForm = (formEl: FormInstance | undefined, type: boolean) => {
  if (!formEl) return;
  formEl.resetFields();
  if (type) {
    dialogVisible.value = false;
  }
};
const resetPassword = (row: any) => {
  ElMessageBox.confirm(`是否重置"${row.userName}"的密码?`, "提示", {
    confirmButtonText: "重置",
    cancelButtonText: "取消",
    type: "warning",
  }).then(() => {
    resetPw({ id: row.id }).then((res: any) => {
      ElMessage({
        type: "success",
        message: `重置成功,新密码为：${res}`,
      });
      onSearch(false);
    });
  });
};
const edit = (row: any) => {
  dialogTitle.value = "编辑用户";
  dialogVisible.value = true;
  setTimeout(() => {
    for (let key in row) {
      const k = key as keyof ruleFormConfigItem;
      setField(ruleForm, k, row[k]);
    }
    console.log(ruleForm);
  }, 200);
  ruleForm.compCode = row.compCode
  ruleForm.confirmPassword = row.password
  getRoleList();
};
const handleSizeChange = (val: number) => {
  userManuallySetPageSize.value = true; // 设置标志位表示用户手动修改了页面大小
  queryForm.pageSize = val;
  onSearch(true);
};
const handleCurrentChange = (val: number) => {
  queryForm.pageIndex = val;
  onSearch(false);
};
const handleClose = (formEl: any) => {
  if (!formEl) return;
  formEl.resetFields();
  ruleForm.id = "";
};
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid: any, fields: any) => {
    if (valid) {
      ruleForm.compCode = ruleForm.compCode || queryForm.condition.compCode;
      let param = { ...ruleForm };
      param.phone = param.phone ? param.phone : "";
      saveOrUpdate(param).then((res: any) => {
        ElMessage({
          type: "success",
          message: dialogTitle.value + "成功",
        });
        onSearch(false);
        dialogVisible.value = false;
      });
    } else {
      console.log("error submit!", fields);
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_unref(userInfo).id === '0')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_el_select, {
                  modelValue: _unref(queryForm).condition.compCode,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(queryForm).condition.compCode) = $event)),
                  placeholder: "请选择",
                  onChange: getDeptTreeFn
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(talentArr.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.compCode,
                        label: item.compName,
                        value: item.compCode
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, {
            plain: "",
            icon: _unref(Plus),
            onClick: newlyAdded
          }, {
            default: _withCtx(() => [
              _createTextVNode("新 增")
            ]),
            _: 1
          }, 8, ["icon"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(ElTree), {
              modelValue: _unref(queryForm).condition.deptId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(queryForm).condition.deptId) = $event)),
              ref_key: "treeRef",
              ref: treeRef,
              data: deptTree.value,
              "default-expand-all": "",
              "show-checkbox": "",
              "node-key": "id",
              props: defaultProps,
              onCheck: handleCheck
            }, null, 8, ["modelValue", "data"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_form, {
            inline: true,
            model: _unref(queryForm),
            class: "demo-form-inline",
            ref_key: "queryFormRef",
            ref: queryFormRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "角色",
                prop: "condition.roleId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(queryForm).condition.roleId,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(queryForm).condition.roleId) = $event)),
                    placeholder: "角色",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.roleName,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "用户姓名",
                prop: "condition.userName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(queryForm).condition.userName,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(queryForm).condition.userName) = $event)),
                    clearable: "",
                    placeholder: "用户姓名",
                    class: "unifiedInputBoxWidth"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { class: "el-refresh-button" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    icon: _unref(Search),
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (onSearch(true)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查 询")
                    ]),
                    _: 1
                  }, 8, ["icon"]),
                  _createVNode(_component_el_button, {
                    plain: "",
                    icon: _unref(RefreshRight),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (resetForm(queryFormRef.value, false)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("重 置")
                    ]),
                    _: 1
                  }, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_table, {
            data: tableData.value,
            border: "",
            style: {"width":"100%"},
            height: "100%",
            onRowMounted: calculateTableRows
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "index",
                label: "序号",
                width: "60",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "userName",
                label: "用户姓名",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "userAccount",
                label: "登录账号",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "deptName",
                label: "机构名称",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "deptCode",
                label: "机构编码",
                align: "center"
              }),
              (_unref(isAdmin))
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    prop: "compCode",
                    label: "租户编码",
                    align: "center"
                  }))
                : _createCommentVNode("", true),
              (_unref(isAdmin))
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 1,
                    prop: "compName",
                    label: "租户名称",
                    align: "center"
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table_column, {
                prop: "phone",
                label: "联系电话",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "roleName",
                label: "角色",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "roleAuth",
                label: "登录权限",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "created",
                label: "创建时间",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                prop: "enableFlag",
                label: "账号状态",
                align: "center",
                width: "100"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_switch, {
                    modelValue: scope.row.enableFlag,
                    "onUpdate:modelValue": ($event: any) => ((scope.row.enableFlag) = $event),
                    "active-value": "Y",
                    "inactive-value": "N",
                    onChange: ($event: any) => (updateEnableFlagFn($event, scope.row.id))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                fixed: "right",
                label: "操作",
                width: "180",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    link: "",
                    type: "primary",
                    size: "small",
                    onClick: _withModifiers(($event: any) => (resetPassword(scope.row)), ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 重置密码 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_el_button, {
                    link: "",
                    type: "primary",
                    size: "small",
                    onClick: _withModifiers(($event: any) => (edit(scope.row)), ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 编 辑 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_pagination, {
            background: "",
            layout: "total, sizes, prev, pager, next",
            "page-sizes": pageSizes.value,
            total: total.value,
            "current-page": _unref(queryForm).pageIndex,
            "onUpdate:current-page": _cache[6] || (_cache[6] = ($event: any) => ((_unref(queryForm).pageIndex) = $event)),
            "page-size": _unref(queryForm).pageSize,
            "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((_unref(queryForm).pageSize) = $event)),
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["page-sizes", "total", "current-page", "page-size"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((dialogVisible).value = $event)),
        title: dialogTitle.value,
        width: "500px",
        onClose: _cache[20] || (_cache[20] = ($event: any) => (handleClose(ruleFormRef.value))),
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_18, [
            _createVNode(_component_el_button, {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (resetForm(ruleFormRef.value, true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("取 消")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (submitForm(ruleFormRef.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 确 定 ")
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: ruleForm,
            rules: rules,
            "label-width": "80px",
            class: "demo-ruleForm",
            size: formSize.value,
            "status-icon": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "归属机构",
                prop: "deptId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tree_select, {
                    style: {"width":"100%"},
                    placeholder: "归属机构",
                    "check-strictly": "",
                    clearable: "",
                    modelValue: ruleForm.deptId,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((ruleForm.deptId) = $event)),
                    data: deptTree.value,
                    "render-after-expand": false,
                    onCurrentChange: changeCompCode
                  }, null, 8, ["modelValue", "data"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "用户姓名",
                prop: "userName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.userName,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((ruleForm.userName) = $event)),
                    clearable: "",
                    maxlength: "22",
                    placeholder: "请输入用户姓名"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "登录账号",
                prop: "userAccount"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.userAccount,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((ruleForm.userAccount) = $event)),
                    clearable: "",
                    minlength: 8,
                    maxlength: 18,
                    placeholder: "请输入登录账号",
                    disabled: !!ruleForm.id
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "联系电话",
                prop: "phone"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.phone,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((ruleForm.phone) = $event)),
                    type: "number",
                    maxlength: "11",
                    placeholder: "请输入联系电话"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "密码",
                prop: "password"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "请输入密码",
                    modelValue: ruleForm.password,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((ruleForm.password) = $event)),
                    "show-password": "",
                    type: "password",
                    maxlength: 18
                  }, null, 8, ["modelValue"]),
                  (ruleForm.password)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["pwd-bar", { 'pwd-weak': _unref(strengthLevel) >= 1 }])
                          }, null, 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["pwd-bar", { 'pwd-medium': _unref(strengthLevel) >= 2 }])
                          }, null, 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["pwd-bar", { 'pwd-strong': _unref(strengthLevel) >= 3 }])
                          }, null, 2)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "确认密码",
                prop: "confirmPassword"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    placeholder: "请确认密码",
                    modelValue: ruleForm.confirmPassword,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((ruleForm.confirmPassword) = $event)),
                    "show-password": "",
                    maxlength: 18
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "用户角色",
                prop: "roleId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: ruleForm.roleId,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((ruleForm.roleId) = $event)),
                    class: "ml-4"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_radio, {
                          label: item.id,
                          key: item.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.roleName), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "账号状态",
                prop: "enableFlag"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: ruleForm.enableFlag,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((ruleForm.enableFlag) = $event)),
                    "active-value": "Y",
                    "inactive-value": "N"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "备 注",
                prop: "remark"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: ruleForm.remark,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((ruleForm.remark) = $event)),
                    type: "textarea",
                    "show-word-limit": "",
                    maxlength: "120",
                    autosize: { minRows: 4, maxRows: 6 }
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules", "size"]),
          _hoisted_17
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ]))
}
}

})